import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import FleetWebApi from "../Api/FleetWebApi";
function Tests(props) {
  const [responses, setResponses] = useState("");
  const handleTest1Submit = () => {
    FleetWebApi.simStateChange(
      [
        "WG0013465754",
        "WF0011314341",
        "CC2010457634",
        "WF0010733037",
        "WF0010874847",
        "WG0013465754",
        "CC0010787060",
        "CC0010687955",
        "WF0010598331",
        "WC0010136595",
        "CC0010172378",
        "fakeserialhahalol",
        "CC0010202638",
        "WG0013465754",
        "CC0010207557",
      ],
      "deactivate",
      "FleetWeb coroutine test",
      "deactivating"
    ).then(
      (result) => {
        console.log(result);
        setResponses(responses + "\n" + JSON.stringify(result));
      },
      (error) => {
        console.log(error);
        setResponses(responses + "\n" + JSON.stringify(error));
      }
    );
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
        <Button
          variant="contained"
          type="test"
          color="primary"
          label="Add Note"
          fullWidth={true}
          size="large"
          style={{ marginTop: 38 }}
          onClick={handleTest1Submit}
        >
          Test /v2/particle/handlesim
        </Button>
        <br />
      </Grid>
      <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
        <TextField
          id="console"
          label={"Response console"}
          multiline
          minRows={5}
          maxRows={5}
          variant="outlined"
          fullWidth
          disabled={true}
          color="info"
          value={responses}
          autoFocus={true}
        />
      </Grid>
    </Grid>
  );
}

export default Tests;
